import { ReactNode } from 'react';
import { sanitize } from '../../utils/sanitize';

export interface InfoItemProps {
  key: string;
  structured?: boolean;
  value: ReactNode | string;
}

export interface InfoProps {
  /** Type of info */
  type?: 'simple' | 'columns' | 'extended' | 'regular' | 'table';
  /** Info objects */
  items?: InfoItemProps[];
  /** Additional class */
  className?: string;
}

/** List of key, value pairs */
export const Info = ({
  type = 'simple',
  items,
  className,
  ...props
}: InfoProps) => {
  if (!items || !items?.map) {
    return null;
  }
  return (
    <div className={['info', `info--${type}`, className].join(' ')} {...props}>
      <dl className="info__contents">
        {items.map((item, i) => {
          return (
            <div key={i}>
              {typeof item.value !== 'undefined' && (
                <>
                  <dt className="info__key">{item.key}</dt>
                  <dd className="info__value">
                    {item.structured && typeof item.value === 'string' ? (
                      <div
                        dangerouslySetInnerHTML={{ __html: sanitize(item.value) }}
                      />
                    ) : (
                      item.value
                    )}
                  </dd>
                </>
              )}
            </div>
          );
        })}
      </dl>
    </div>
  );
};
